import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

export const ForgetPasswordMailSlicer = createSlice({
  name: "ForgetPasswordMail",
  initialState: {
    data: {},
    isLoading: false,
  } as IReduxState<null>,
  reducers: {
    forgetPasswordMail: (state, _) => {
      state.isLoading = true;
    },
    successForgetPasswordMail: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureForgetPasswordMail: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearForgetPasswordMail: (state) => {
      state.data = {};
    },
  },
});

export const {
  forgetPasswordMail,
  successForgetPasswordMail,
  failureForgetPasswordMail,
  clearForgetPasswordMail,
} = ForgetPasswordMailSlicer.actions;

export default ForgetPasswordMailSlicer.reducer;
